import { TaxRate } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { assertUnreachable } from '@dreryk/react-common';

export const getDefaultTaxRate = (taxRates: TaxRate[]): TaxRate => {
   const foundTaxRate = taxRates.find((taxRate) => taxRate.defaultRate);
   return foundTaxRate ?? assertUnreachable(undefined);
};

export const getTaxRate = (taxRates: TaxRate[], id: number): TaxRate => {
   const foundTaxRate = taxRates.find((taxRate) => taxRate.id === id) ?? null;
   return foundTaxRate ?? getDefaultTaxRate(taxRates);
};
